import { Action } from '@ngrx/store';

import { AddToCartEvent } from '../../models';
import { PriceTypes } from '~shared/modules/price-type-toggler/models/price-types.enum';

export enum CartActionTypes {
  ADD_TO_CART = '[Buyer] Cart add',
  ADD_TO_CART_SUCCESS = '[Buyer] Cart add success',
  ADD_TO_CART_FAILURE = '[Buyer] Cart add failure',

  GET_CART_TOTAL_QUANTITY = '[Buyer] Get cart total quantity',
  GET_CART_TOTAL_QUANTITY_SUCCESS = '[Buyer] Get cart total quantity success',
  GET_CART_TOTAL_QUANTITY_FAILURE = '[Buyer] Get cart total quantity failure',

  SHOW_MINI_CART = '[Buyer] Show mini cart',
  CLOSE_MINI_CART = '[Buyer] Close mini cart'
}

export class AddToCart implements Action {
  readonly type = CartActionTypes.ADD_TO_CART;

  constructor(public payload: AddToCartEvent) {
  }
}

export class AddToCartSuccess implements Action {
  readonly type = CartActionTypes.ADD_TO_CART_SUCCESS;

  constructor(public accountType: PriceTypes) {
  }
}

export class AddToCartFailure implements Action {
  readonly type = CartActionTypes.ADD_TO_CART_FAILURE;

  constructor(public payload: { error: any | null }) {
  }
}

export class GetCartTotalQuantity implements Action {
  readonly type = CartActionTypes.GET_CART_TOTAL_QUANTITY;
}

export class GetCartTotalQuantitySuccess implements Action {
  readonly type = CartActionTypes.GET_CART_TOTAL_QUANTITY_SUCCESS;

  constructor(public payload: { count: number | null }) {
  }
}

export class GetCartTotalQuantityFailure implements Action {
  readonly type = CartActionTypes.GET_CART_TOTAL_QUANTITY_FAILURE;

  constructor(public payload: { error: string | null }) {
  }
}

export class ShowMiniCart implements Action {
  readonly type = CartActionTypes.SHOW_MINI_CART;
  constructor() {
  }
}

export class CloseMiniCart implements Action {
  readonly type = CartActionTypes.CLOSE_MINI_CART;
  constructor() {
  }
}


export type CartActionsUnion =
  AddToCart
  | AddToCartSuccess
  | ShowMiniCart
  | CloseMiniCart
  | AddToCartFailure
  | GetCartTotalQuantity
  | GetCartTotalQuantitySuccess
  | GetCartTotalQuantityFailure;
